import { createTheme } from "@mui/material//styles";
import { alertClasses } from "@mui/material/Alert";

const flowTheme = createTheme({
    palette: {
        primary: {
            main: "#0077B8",
            light: "#00B0F0",
        },
        secondary: {
            main: "#e0e0e0",
        },
    },
    typography: {
        h6: {
            fontSize: "1.25rem",
            fontWeight: 500,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => {
                    return ({
                        gap: 8,
                        // prettier-ignore
                        ...(ownerState.variant === "outlined" &&
                            ownerState.color === "primary" && {
                            backgroundColor: "#fff",
                        }),
                    });
                },
            },
        },
        MuiAlert: {
            defaultProps: {
                variant: "transparent",
            },
            styleOverrides: {
                root: {
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontWeight: 500,
                    lineHeight: 1.5,
                },
                message: {
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontWeight: 500,
                    lineHeight: 1.5,
                },
            },
            variants: [
                {
                    props: { variant: "transparent" },
                    style: ({ theme }) => ({
                        border: "none",
                        paddingLeft: 0,
                        paddingRight: 0,
                        [`&.${alertClasses.colorError}`]: {
                            color: theme.palette.error.main,
                        },
                        [`&.${alertClasses.colorWarning}`]: {
                            color: theme.palette.warning.main,
                        },
                        [`&.${alertClasses.colorSuccess}`]: {
                            color: theme.palette.success.main,
                        },
                        [`&.${alertClasses.colorInfo}`]: {
                            color: theme.palette.info.main,
                        },
                    }),
                },
            ],
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    outline: "unset",
                },
            },
        },
        MuiCheckbox: {},
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgroundColor: "#fff",
                },
                input: {
                    backgroundColor: "#fff",
                },
            },
        },
        MuiIconButton: {
            variants: [
                {
                    props: { variant: "square" },
                    style: {
                        borderRadius: "4px",
                        padding: "12px",
                        minHeight: "45px",
                        minWidth: "45px",
                        backgroundColor: "rgba(0, 0, 0, 0.03)",
                        ":hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.05)",
                        },
                    },
                },
                {
                    props: { variant: "outlinedSquare" },
                    style: {
                        borderRadius: "4px",
                        padding: "12px",
                        height: "42px",
                        width: "40px",
                        backgroundColor: "#fff",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        ":hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.05)",
                        },
                    },
                },
            ],
        },
    },
});

export default flowTheme;
